module.exports = __webpack_public_path__ + "img/accessory_item_03.3f063254.svg";